import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BBResponseContainer } from '../carrier/response-container';
import { timeout } from 'rxjs/operators';

@Injectable()
export class StepDtRemovalService {

  constructor(private http: HttpClient) {
  }
  
  /**
   * Get all the active machines by it's barcode
   * @param barcode 
   * @param active 
   */
  getActiveMachinesByBarcode(barcode: string, active: boolean) {
    
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine';
    
    let requestParam = new HttpParams()
                          .set("barcode", barcode)
                          .set("active", String(active));
                          
    const options = url ? { params: requestParam } : {};

    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

}
